import { render, staticRenderFns } from "./PlanStackSkeleton.vue?vue&type=template&id=6e202a97&scoped=true&"
import script from "./PlanStackSkeleton.vue?vue&type=script&lang=js&"
export * from "./PlanStackSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./PlanStackSkeleton.vue?vue&type=style&index=0&id=6e202a97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e202a97",
  null
  
)

component.options.__file = "PlanStackSkeleton.vue"
export default component.exports